import { render, staticRenderFns } from "./CustomDataTable.vue?vue&type=template&id=114ab28f&scoped=true"
import script from "./CustomDataTable.vue?vue&type=script&lang=js"
export * from "./CustomDataTable.vue?vue&type=script&lang=js"
import style0 from "./CustomDataTable.vue?vue&type=style&index=0&id=114ab28f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "114ab28f",
  null
  
)

export default component.exports